import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
// Entfernt: Externe CSS-Bundles, die Warnungen beim Minifizieren verursachten
import App from "./App.tsx";
import { AppWrapper } from "./components/common/PageMeta.tsx";
import { ThemeProvider } from "./context/ThemeContext.tsx";

// ============================================================================
// Globale Fallbacks für dynamische Chunk-Fehler (tritt v. a. nach Deploys auf)
// ============================================================================
if (typeof window !== "undefined" && import.meta.env.PROD) {
  const CHUNK_ERROR_PATTERNS = [
    "ChunkLoadError",
    "Loading chunk",
    "Failed to fetch dynamically imported module",
    "Importing a module script failed"
  ];

  const hasChunkReloaded = () => sessionStorage.getItem("myfood_chunk_reloaded") === "1";
  const markChunkReload = () => sessionStorage.setItem("myfood_chunk_reloaded", "1");
  const clearChunkReload = () => sessionStorage.removeItem("myfood_chunk_reloaded");

  const handleChunkFailure = () => {
    if (hasChunkReloaded()) {
      // Schon einmal versucht → erneutes Neuladen bringt nichts, daher nur Hinweis
      console.error(
        "[MyFood] Chunk konnte erneut nicht geladen werden. Bitte Cache leeren und Seite neu öffnen."
      );
      clearChunkReload();
      return;
    }

    markChunkReload();
    console.warn("[MyFood] Chunk-Problem erkannt – Seite wird automatisch neu geladen.");
    window.location.reload();
  };

  const matchesChunkPattern = (message?: string) =>
    !!message && CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));

  window.addEventListener("unhandledrejection", (event) => {
    const reason = (event && (event.reason as Error | undefined)) || undefined;
    if (!reason) return;

    const message = reason.message || reason.toString();
    if (matchesChunkPattern(message)) {
      handleChunkFailure();
    }
  });

  window.addEventListener("error", (event) => {
    const message = event?.message;
    if (matchesChunkPattern(message)) {
      handleChunkFailure();
    }
  });

  // Erfolgreiches Laden → Flag zurücksetzen (ansonsten würden spätere Fehler blocken)
  if (hasChunkReloaded()) {
    clearChunkReload();
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <AppWrapper>
        <App />
      </AppWrapper>
    </ThemeProvider>
  </StrictMode>
);
